import React, { ReactNode } from "react";

interface IWebsiteBuilderPopupSectionsProps {
  sections: ReactNode[];
}

export function WebsiteBuilderPopupSections(props: IWebsiteBuilderPopupSectionsProps) {
  const { sections } = props;

  return (
    <div className="website-builder-popup-sections">
      {sections.map((section, index) => (
        <React.Fragment key={index}>
          <div className="popup-section">{section}</div>
          {index < sections.length - 1 && <hr className="popup-section-divider" />}
        </React.Fragment>
      ))}
    </div>
  );
}
